import { gql } from 'apollo-boost'

export const stepFragment = {
  step: gql`
    fragment ProcedureStepDetails on ProcedureStep {
      id
      title
      type
      order
      media {
        id
        type
        url
        bucket
        bucketFilename
        originalFilename
        size
      }
      parent {
        stepId
        exitId
      }
      transitionType
      exits{
        id
        valueType
        value
        valueMin
        valueMax
      }
      errors {
        stepName
        error
      }
    }`
}
